<template>
  <div></div>
</template>

<script>
import loadScriptOnce from 'load-script-once'

const MapTypeId = {
  'ROADMAP': 1,
  'NORMAL': 1,
  'SKYVIEW': 2,
  'HYBRID': 3,
  'OVERLAY': 4,
  'ROADVIEW': 5,
  'TRAFFIC': 6,
  'TERRAIN': 7,
  'BICYCLE': 8,
  'BICYCLE_HYBRID': 9,
  'USE_DISTRICT': 10
}

const EVENTS = [
  // 'center_changed',
  // 'zoom_start',
  'zoom_changed',
  // 'bounds_changed',
  'click',
  'dblclick',
  'rightclick',
  // 'mousemove',
  // 'dragstart',
  // 'drag',
  'dragend',
  'idle'
  // 'tilesloaded',
  // 'maptypeid_changed'
]

export default {
  name: 'KakaoMap',
  props: {
    appKey: {
      type: String,
      required: true
    },
    libraries: {
      type: Array,
      default: () => []
    },
    center: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      default: undefined
    },
    mapTypeId: {
      type: Number,
      default: undefined
    },
    draggable: {
      type: Boolean,
      default: undefined
    },
    scrollwheel: {
      type: Boolean,
      default: undefined
    },
    disableDoubleClick: {
      type: Boolean,
      default: undefined
    },
    disableDoubleClickZoom: {
      type: Boolean,
      default: undefined
    },
    projectionId: {
      type: String,
      default: undefined
    },
    tileAnimation: {
      type: Boolean,
      default: undefined
    },
    keyboardShortcuts: {
      type: [Boolean, Object],
      default: undefined
    }
  },
  data: () => ({
    map: null,
    geocoder: null,
    currentTypeId: MapTypeId.NORMAL,
    markers: [],
    customOverlays: []
  }),
  mounted () {
    //
  },
  watch: {
    /*
    level () {
      if (!this.map) {
        return
      }
      this.map.setLevel(this.level)
    },
    center: {
      handler () {
        if (!this.map) {
          return
        }
        this.map.setCenter(new daum.maps.LatLng(this.center.lat, this.center.lng))
      },
      deep: true
    }
    */
  },
  methods: {
    init () {
      loadScriptOnce(`//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=${this.appKey}&libraries=${this.libraries.join(',')}`, (err) => {
        if (err) {
          console.error(err)
          return
        }
        /* global daum */
        daum.maps.load(() => {
          this.render()
          this.bindEvents()
          this.$emit('load', this.map)
        })
      })
    },
    render () {
      const options = { // 지도를 생성할 때 필요한 기본 옵션
        center: new daum.maps.LatLng(this.center.lat, this.center.lng), // 지도의 중심좌표.
        level: this.level, // 지도의 레벨(확대, 축소 정도)
        mapTypeId: this.mapTypeId, // 지도 타입
        draggable: this.draggable,
        scrollwheel: this.scrollwheel,
        disableDoubleClick: this.disableDoubleClick,
        disableDoubleClickZoom: this.disableDoubleClickZoom,
        projectionId: this.projectionId,
        tileAnimation: this.tileAnimation,
        keyboardShortcuts: this.keyboardShortcuts,
        // 지도 줌아웃 제한
        minLevel: 1,
        maxLevel: 9
      }
      this.map = new daum.maps.Map(this.$el, options) // 지도 생성 및 객체 리턴
      this.geocoder = new daum.maps.services.Geocoder()
      // 테스트 타일
      /*
      daum.maps.Tileset.add('TILE_NUMBER',
        new daum.maps.Tileset({
          width: 160, // 256
          height: 160,
          getTile: function (x, y, z) {
            let div = document.createElement('div')
            div.innerHTML = x + ', ' + y + ', ' + z
            div.style.fontSize = '20px'
            div.style.lineHeight = '200px'
            div.style.textAlign = 'center'
            div.style.color = '#4D4D4D'
            div.style.border = '1px dashed #ff3115'
            return div
          }
        }))
      this.map.addOverlayMapTypeId(daum.maps.MapTypeId.TILE_NUMBER)
      */
    },
    bindEvents () {
      const handlers = {
        bounds_changed: this.onChange,
        idle: this.onChange
      }
      for (let event of EVENTS) {
        this.bindEvent(event, handlers[event])
      }
    },
    bindEvent (event, handler) {
      daum.maps.event.addListener(this.map, event, (...args) => {
        this.$emit(event, args)
        if (typeof handler === 'function') {
          handler()
        }
      })
    },
    onChange () {
      /*
      const level = this.map.getLevel()
      const latlng = this.map.getCenter()
      this.$emit('update:level', level)
      this.$emit('update:center', {
        lat: latlng.getLat(),
        lng: latlng.getLng()
      })
      */
    },
    // 특정위치 행정동 주소 반환
    searchAddrFromCoords (coords, callback) { // 좌표로 행정동 주소 정보를 요청합니다
      this.geocoder.coord2RegionCode(coords.getLng(), coords.getLat(), callback)
    },
    // 맵모드 변경
    setOverlayMapTypeId (maptype) {
      // console.log('maptype:' + maptype + ' / ' + this.mapTypeId)
      if (this.mapTypeId === maptype) {
        this.map.removeOverlayMapTypeId(this.mapTypeId)
        this.$emit('update:mapTypeId', MapTypeId.NORMAL)
        return
      }
      if (this.mapTypeId !== MapTypeId.NORMAL) { // 기존 제거
        this.map.removeOverlayMapTypeId(this.mapTypeId)
        this.$emit('update:mapTypeId', MapTypeId.NORMAL)
      }
      if (maptype !== MapTypeId.NORMAL) {
        this.map.addOverlayMapTypeId(maptype)
        this.$emit('update:mapTypeId', maptype)
      }
    },
    // 로드뷰 시작
    showRoadView (latlng, roadviewContainer) {
      try {
        var roadview = new daum.maps.Roadview(roadviewContainer) // 로드뷰 객체
        var roadviewClient = new daum.maps.RoadviewClient() // 좌표로부터 로드뷰 파노ID를 가져올 로드뷰 helper객체
        var position = new daum.maps.LatLng(latlng.getLat(), latlng.getLng())
        // 특정 위치의 좌표와 가까운 로드뷰의 panoId를 추출하여 로드뷰를 띄운다.
        roadviewClient.getNearestPanoId(position, 50, function (panoId) {
          roadview.setPanoId(panoId, position) // panoId와 중심좌표를 통해 로드뷰 실행
        })
      } catch (error) {
        window.location = 'http://get.adobe.com/flashplayer/'
      } finally {
        //
      }
    },
    // 커스텀 오버레이 등록
    addCustomOverlay (name, op, content, clickCallback, overCallback, outCallback) { // customOverlays CustomOverlay
      let overlays = this.customOverlays.find(overlay => overlay.name === name)
      if (overlays === undefined) {
        overlays = this.customOverlays[this.customOverlays.push({ name: name, list: [] }) - 1]
      }
      let overlay = new daum.maps.CustomOverlay(op)
      let onclick = (e) => {
        if (clickCallback) {
          clickCallback(e)
        }
      }
      let onover = (e) => {
        if (overCallback) {
          overCallback(e)
        }
      }
      let onout = (e) => {
        if (outCallback) {
          outCallback(e)
        }
      }
      this.addEventHandle(content, 'click', onclick)
      this.addEventHandle(content, 'mouseover', onover)
      this.addEventHandle(content, 'mouseout', onout)
      overlay.setMap(this.map) // 지도 위에 마커를 표출합니다
      overlays.list.push({overlay: overlay, content: content, onclick: onclick, onover: onover, onout: onout}) // 배열에 생성된 마커를 추가합니다

      return overlay
    },
    // 커스텀 오버레이 지우기
    removeCustomOverlay (name) {
      const overlays = this.customOverlays.find(overlay => overlay.name === name)
      if (overlays !== undefined) {
        for (var i = 0; i < overlays.list.length; i++) {
          this.removeEventHandle(overlays.list[i].content, 'click', overlays.list[i].onclick)
          this.removeEventHandle(overlays.list[i].content, 'mouseover', overlays.list[i].onover)
          this.removeEventHandle(overlays.list[i].content, 'mouseout', overlays.list[i].onout)
          overlays.list[i].content.parentNode.removeChild(overlays.list[i].content)
          overlays.list[i].overlay.setMap(null)
          overlays.list[i] = []
        }
        overlays.list = []
      }
    },
    // 마커등록
    addMarker (name, loc, imgurl, imgsize, options) {
      let markers = this.markers.find(marker => marker.name === name)
      if (markers === undefined) {
        markers = this.markers[this.markers.push({ name: name, list: [] }) - 1]
      }
      const position = new daum.maps.LatLng(loc.lat, loc.lng)
      let imageSize = new daum.maps.Size(imgsize.x, imgsize.y) // 마커 이미지의 크기
      let markerImage = new daum.maps.MarkerImage(imgurl, imageSize, options)
      let marker = new daum.maps.Marker({
        position: position, // 마커의 위치
        image: markerImage
      })

      marker.setMap(this.map) // 지도 위에 마커를 표출합니다
      markers.list.push({ marker: marker }) // 배열에 생성된 마커를 추가합니다

      return marker
    },
    // 마커지우기
    removeMarker (name) {
      const markers = this.markers.find(marker => marker.name === name)
      if (markers !== undefined) {
        for (var i = 0; i < markers.list.length; i++) {
          markers.list[i].marker.setMap(null)
        }
        markers.list = []
      }
    },
    // 마커 전체 지우기
    removeAllMarker (name) {
      const markerSize = this.markers.length
      for (var j = 0; j < markerSize; j++) {
        const markers = this.markers[j]
        if (markers !== undefined) {
          for (var i = 0; i < markers.list.length; i++) {
            markers.list[i].marker.setMap(null)
          }
          markers.list = []
        }
      }
    },
    // ****** 기본함수 ******
    panTo (lat, lng) {
      var moveLatLng = new daum.maps.LatLng(lat, lng)
      this.map.panTo(moveLatLng)
    },
    newSize (x, y) {
      return new daum.maps.Size(x, y)
    },
    newPoint (x, y) {
      return new daum.maps.Point(x, y)
    },
    newLatLng (x, y) {
      return new daum.maps.LatLng(x, y)
    },
    newPlaces () {
      return new daum.maps.services.Places(this.map)
    },
    newCustomOverlay (op) {
      return new daum.maps.CustomOverlay(op)
    },
    newPolyline (op) {
      return new daum.maps.Polyline(op)
    },
    newInfoWindow (op) {
      return new daum.maps.InfoWindow(op)
    },
    newCircle (op) {
      return new daum.maps.Circle(op)
    },
    newPolygon (op) {
      return new daum.maps.Polygon(op)
    },
    getMaps () {
      return daum.maps
    },
    addListener (target, name, callback) {
      daum.maps.event.addListener(target, name, callback)
    },
    removeListener (target, name, callback) {
      daum.maps.event.removeListener(target, name, callback)
    },
    addEventHandle (target, type, callback) {
      if (target.addEventListener) {
        target.addEventListener(type, callback)
      } else {
        target.attachEvent('on' + type, callback)
      }
    },
    removeEventHandle (target, type, callback) {
      if (target.removeEventListener) {
        target.removeEventListener(type, callback)
      } else {
        target.detachEvent('on' + type, callback)
      }
    },
    addressSearch (addr) {
      const _this = this
      this.geocoder.addressSearch(addr, function (result, status) {
        if (status === daum.maps.services.Status.OK) {
          var coords = new daum.maps.LatLng(result[0].y, result[0].x)
          // 결과값으로 받은 위치를 마커로 표시합니다
          var marker = new daum.maps.Marker({
            position: coords
          })
          marker.setMap(_this.map)
          /*
          // 인포윈도우로 장소에 대한 설명을 표시합니다
          var infowindow = new daum.maps.InfoWindow({
            content: '' // <div style="width:150px;text-align:center;padding:6px 0;">우리회사</div>
          })
          infowindow.open(_this.map, marker)
          */
          // 지도의 중심을 결과값으로 받은 위치로 이동시킵니다
          _this.map.setCenter(coords)
        }
      })
    }
  },
  MapTypeId: MapTypeId
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/plugin/KakaoMap.vue